export enum TourStatus {
  Inactive,
  Active
}
